'use client'

import React from 'react'

import { HtmlContent } from '@portal/lib/html-content'
import { parseContent } from '@portal/news-lib/read-more'

import { PostPublishingDate } from '@/features/post-publishing-date'
import { PostTag } from '@/features/post-tag'
import { PostTitle } from '@/features/post-title'
import { PostTranslateButton, useTranslation } from '@/features/post-translate-button'
import { ReactionPanel } from '@/packages/news-ui/reaction-panel'

import { PostLayout } from './post-layout'
import type { Post } from './query/types'

export function PostView({ post }: { post: Post }) {
    const { data, handleTranslateButtonClick, isTranslated, lang } = useTranslation(post)

    return (
        <PostLayout>
            <PostLayout.Header>
                <PostTag tag={post.label} />
                <PostTitle title={data?.title ?? post.title} showStar={post.featured} />

                <div className="d-flex">
                    <PostPublishingDate publishTime={post.publishTime} lang={lang} />
                    <div className="ml-auto">
                        {/* Suspense needed because PostTranslateButton uses useLoggedIn() which calls React.use() with a Promise */}
                        <React.Suspense>
                            <PostTranslateButton isTranslated={isTranslated} onClick={handleTranslateButtonClick} />
                        </React.Suspense>
                    </div>
                </div>
            </PostLayout.Header>

            <PostLayout.Content>
                <PostContent initialContent={data?.content ?? post.content} />
            </PostLayout.Content>

            <PostLayout.Footer>
                <ReactionPanel postId={post.id} />
            </PostLayout.Footer>
        </PostLayout>
    )
}

type PostContentProps = {
    initialContent: string
}

function PostContent({ initialContent }: PostContentProps) {
    const { content } = parseContent({ content: initialContent, removeCut: true })

    return <HtmlContent html={content} />
}
